// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.filtre-search {
  max-width: 900px;
  margin: 0 auto;
  padding: 40px 20px;
}
/* MOBILE */
@media (max-width: 480px) {
  .filtre-search {
  max-width: 900px;
  margin: 0 auto;
  padding: 0px;
}
}

/* Hero */
.filtre-hero {
  text-align: center;
  margin-bottom: 36px;
}
.filtre-hero-icon {
  font-size: 3rem;
  color: #ffcc00;
  margin-bottom: 12px;
}
.filtre-hero-title {
  font-size: 2.8rem;
  font-weight: 800;
  color: #1a1a1a;
  margin-bottom: 10px;
}
.filtre-hero-subtitle {
  font-size: 1.8rem;
   font-weight: 900;
  font-family: 'Baloo 2', cursive;
  color: #f2c94c; /* galben */
  text-shadow:
    1px 1px 0 black,
    -1px 1px 0 black,
    1px -1px 0 black,
    -1px -1px 0 black;
  margin:auto;
  line-height: 1;
}
/* TABLET */
@media (max-width: 768px) {
  .filtre-hero-subtitle {
    margin-top: 20px;
    font-size: 1rem;
  }
}

/* Butoane imagine */
.filtre-imagine-butoane {
  display: flex;
  justify-content: center;
  gap: 24px;
  margin-bottom: 36px;
  flex-wrap: wrap;
}

.imagine-card {
  background: #fff;
  border: 3px solid #1a1a1a;
  border-radius: 20px;
  padding: 32px;
  width: 150px;
  height: 150px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.2s;
  box-shadow: 5px 5px 0px #1a1a1a;
  text-align: center;
  gap: 10px;
}
.imagine-card:hover {
  transform: translate(-3px, -3px);
  box-shadow: 9px 9px 0px black;
  border-color: black;
}
.imagine-icon {
  font-size: 2.5rem;
  color: #1a1a1a;
}
.imagine-card:hover .imagine-icon { color: #ffcc00; }
.imagine-card span {
  font-weight: 700;
  font-size: 0.8rem;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

/* Divider */
.filtre-divider {
  display: flex;
  align-items: center;
  gap: 16px;
  margin-bottom: 28px;
  color: #aaa;
  font-size: 12px;
  font-weight: 600;
  letter-spacing: 1px;
}
.filtre-divider::before,
.filtre-divider::after {
  content: "";
  flex: 1 1;
  height: 1px;
  background: #e5e7eb;
}

/* Avansate box */
.filtre-avansate {
  background: #f9fafb;
  border-radius: 20px;
  padding: 28px;
  border: 1.5px solid #e5e7eb;
}
.filtre-avansate h3 {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 20px;
  font-size: 17px;
  color: #1a1a1a;
}

/* Body — preview + grid side by side */
.filtre-body {
  display: flex;
  gap: 24px;
  align-items: flex-start;
  margin-bottom: 20px;
}

/* Preview imagine în filtre */
.filtre-preview {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  flex-shrink: 0;
}
.preview-wrapper {
  position: relative;
  display: inline-block;
}
.preview-img {
  width: 130px;
  height: 130px;
  object-fit: cover;
  border-radius: 14px;
  border: 3px solid #ffcc00;
  box-shadow: 3px 3px 0px #1a1a1a;
}
.btn-remove-preview {
  position: absolute;
  top: -8px; right: -8px;
  background: #dc2626;
  color: white;
  border: none;
  border-radius: 50%;
  width: 24px; height: 24px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 11px;
}
.preview-label {
  display: flex;
  align-items: center;
  gap: 5px;
  font-size: 12px;
  color: #ffcc00;
  font-weight: 600;
}

/* Grid filtre */
.filtre-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(160px, 1fr));
  gap: 14px;
  flex: 1 1;
}

.filter-group {
  display: flex;
  flex-direction: column;
  gap: 5px;
}
.filter-group label {
  display: flex;
  align-items: center;
  gap: 5px;
  font-size: 12px;
  font-weight: 600;
  color: #666;
  text-transform: uppercase;
  letter-spacing: 0.4px;
}
.filter-group select {
  padding: 10px 12px;
  border: 1.5px solid #ddd;
  border-radius: 10px;
  font-size: 14px;
  background: white;
  outline: none;
  cursor: pointer;
}
.filter-group select:focus { border-color: #ffcc00; }

/* Acțiuni */
.filtre-actiuni {
  display: flex;
  gap: 12px;
  flex-wrap: wrap;
}
.btn-cauta {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 12px 28px;
  background: #fdb3fd;
  color: white;
  border: 2px solid #1a1a1a;
  border-radius: 12px;
  font-size: 15px;
  font-weight: 700;
  cursor: pointer;
  box-shadow: 3px 3px 0px #1a1a1a;
  transition: all 0.2s;
}
.btn-cauta:hover {
  transform: translate(-2px, -2px);
  box-shadow: 5px 5px 0px #1a1a1a;
}
.btn-cauta:disabled { opacity: 0.6; cursor: not-allowed; }

.btn-reset {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 12px 20px;
  background: white;
  color: #666;
  border: 1.5px solid #ddd;
  border-radius: 12px;
  font-size: 14px;
  cursor: pointer;
}
.btn-reset:hover { background: #f3f4f6; }

@media (max-width: 700px) {
  .filtre-body { flex-direction: column; }
  .filtre-preview { flex-direction: row; align-items: center; }
  .filtre-grid { grid-template-columns: repeat(2, 1fr); }
  .filtre-hero-title { font-size: 2rem; }
}`, "",{"version":3,"sources":["webpack://./src/components/FiltreSearch.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;AACA,WAAW;AACX;EACE;EACA,gBAAgB;EAChB,cAAc;EACd,YAAY;AACd;AACA;;AAEA,SAAS;AACT;EACE,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,cAAc;EACd,mBAAmB;AACrB;AACA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;AACA;EACE,iBAAiB;GAChB,gBAAgB;EACjB,+BAA+B;EAC/B,cAAc,EAAE,WAAW;EAC3B;;;;qBAImB;EACnB,WAAW;EACX,cAAc;AAChB;AACA,WAAW;AACX;EACE;IACE,gBAAgB;IAChB,eAAe;EACjB;AACF;;AAEA,oBAAoB;AACpB;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,YAAY;EACZ,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,oBAAoB;EACpB,+BAA+B;EAC/B,kBAAkB;EAClB,SAAS;AACX;AACA;EACE,gCAAgC;EAChC,6BAA6B;EAC7B,mBAAmB;AACrB;AACA;EACE,iBAAiB;EACjB,cAAc;AAChB;AACA,oCAAoC,cAAc,EAAE;AACpD;EACE,gBAAgB;EAChB,iBAAiB;EACjB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA,YAAY;AACZ;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;AACA;;EAEE,WAAW;EACX,SAAO;EACP,WAAW;EACX,mBAAmB;AACrB;;AAEA,iBAAiB;AACjB;EACE,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;EACb,2BAA2B;AAC7B;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;EACnB,eAAe;EACf,cAAc;AAChB;;AAEA,uCAAuC;AACvC;EACE,aAAa;EACb,SAAS;EACT,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA,8BAA8B;AAC9B;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;EACR,cAAc;AAChB;AACA;EACE,kBAAkB;EAClB,qBAAqB;AACvB;AACA;EACE,YAAY;EACZ,aAAa;EACb,iBAAiB;EACjB,mBAAmB;EACnB,yBAAyB;EACzB,+BAA+B;AACjC;AACA;EACE,kBAAkB;EAClB,SAAS,EAAE,WAAW;EACtB,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,WAAW,EAAE,YAAY;EACzB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;AACjB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;EACT,SAAO;AACT;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,yBAAyB;EACzB,qBAAqB;AACvB;AACA;EACE,kBAAkB;EAClB,wBAAwB;EACxB,mBAAmB;EACnB,eAAe;EACf,iBAAiB;EACjB,aAAa;EACb,eAAe;AACjB;AACA,6BAA6B,qBAAqB,EAAE;;AAEpD,YAAY;AACZ;EACE,aAAa;EACb,SAAS;EACT,eAAe;AACjB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;EACZ,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,+BAA+B;EAC/B,oBAAoB;AACtB;AACA;EACE,gCAAgC;EAChC,+BAA+B;AACjC;AACA,sBAAsB,YAAY,EAAE,mBAAmB,EAAE;;AAEzD;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,iBAAiB;EACjB,WAAW;EACX,wBAAwB;EACxB,mBAAmB;EACnB,eAAe;EACf,eAAe;AACjB;AACA,mBAAmB,mBAAmB,EAAE;;AAExC;EACE,eAAe,sBAAsB,EAAE;EACvC,kBAAkB,mBAAmB,EAAE,mBAAmB,EAAE;EAC5D,eAAe,qCAAqC,EAAE;EACtD,qBAAqB,eAAe,EAAE;AACxC","sourcesContent":[".filtre-search {\n  max-width: 900px;\n  margin: 0 auto;\n  padding: 40px 20px;\n}\n/* MOBILE */\n@media (max-width: 480px) {\n  .filtre-search {\n  max-width: 900px;\n  margin: 0 auto;\n  padding: 0px;\n}\n}\n\n/* Hero */\n.filtre-hero {\n  text-align: center;\n  margin-bottom: 36px;\n}\n.filtre-hero-icon {\n  font-size: 3rem;\n  color: #ffcc00;\n  margin-bottom: 12px;\n}\n.filtre-hero-title {\n  font-size: 2.8rem;\n  font-weight: 800;\n  color: #1a1a1a;\n  margin-bottom: 10px;\n}\n.filtre-hero-subtitle {\n  font-size: 1.8rem;\n   font-weight: 900;\n  font-family: 'Baloo 2', cursive;\n  color: #f2c94c; /* galben */\n  text-shadow:\n    1px 1px 0 black,\n    -1px 1px 0 black,\n    1px -1px 0 black,\n    -1px -1px 0 black;\n  margin:auto;\n  line-height: 1;\n}\n/* TABLET */\n@media (max-width: 768px) {\n  .filtre-hero-subtitle {\n    margin-top: 20px;\n    font-size: 1rem;\n  }\n}\n\n/* Butoane imagine */\n.filtre-imagine-butoane {\n  display: flex;\n  justify-content: center;\n  gap: 24px;\n  margin-bottom: 36px;\n  flex-wrap: wrap;\n}\n\n.imagine-card {\n  background: #fff;\n  border: 3px solid #1a1a1a;\n  border-radius: 20px;\n  padding: 32px;\n  width: 150px;\n  height: 150px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  transition: all 0.2s;\n  box-shadow: 5px 5px 0px #1a1a1a;\n  text-align: center;\n  gap: 10px;\n}\n.imagine-card:hover {\n  transform: translate(-3px, -3px);\n  box-shadow: 9px 9px 0px black;\n  border-color: black;\n}\n.imagine-icon {\n  font-size: 2.5rem;\n  color: #1a1a1a;\n}\n.imagine-card:hover .imagine-icon { color: #ffcc00; }\n.imagine-card span {\n  font-weight: 700;\n  font-size: 0.8rem;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n/* Divider */\n.filtre-divider {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n  margin-bottom: 28px;\n  color: #aaa;\n  font-size: 12px;\n  font-weight: 600;\n  letter-spacing: 1px;\n}\n.filtre-divider::before,\n.filtre-divider::after {\n  content: \"\";\n  flex: 1;\n  height: 1px;\n  background: #e5e7eb;\n}\n\n/* Avansate box */\n.filtre-avansate {\n  background: #f9fafb;\n  border-radius: 20px;\n  padding: 28px;\n  border: 1.5px solid #e5e7eb;\n}\n.filtre-avansate h3 {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin-bottom: 20px;\n  font-size: 17px;\n  color: #1a1a1a;\n}\n\n/* Body — preview + grid side by side */\n.filtre-body {\n  display: flex;\n  gap: 24px;\n  align-items: flex-start;\n  margin-bottom: 20px;\n}\n\n/* Preview imagine în filtre */\n.filtre-preview {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 8px;\n  flex-shrink: 0;\n}\n.preview-wrapper {\n  position: relative;\n  display: inline-block;\n}\n.preview-img {\n  width: 130px;\n  height: 130px;\n  object-fit: cover;\n  border-radius: 14px;\n  border: 3px solid #ffcc00;\n  box-shadow: 3px 3px 0px #1a1a1a;\n}\n.btn-remove-preview {\n  position: absolute;\n  top: -8px; right: -8px;\n  background: #dc2626;\n  color: white;\n  border: none;\n  border-radius: 50%;\n  width: 24px; height: 24px;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 11px;\n}\n.preview-label {\n  display: flex;\n  align-items: center;\n  gap: 5px;\n  font-size: 12px;\n  color: #ffcc00;\n  font-weight: 600;\n}\n\n/* Grid filtre */\n.filtre-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(160px, 1fr));\n  gap: 14px;\n  flex: 1;\n}\n\n.filter-group {\n  display: flex;\n  flex-direction: column;\n  gap: 5px;\n}\n.filter-group label {\n  display: flex;\n  align-items: center;\n  gap: 5px;\n  font-size: 12px;\n  font-weight: 600;\n  color: #666;\n  text-transform: uppercase;\n  letter-spacing: 0.4px;\n}\n.filter-group select {\n  padding: 10px 12px;\n  border: 1.5px solid #ddd;\n  border-radius: 10px;\n  font-size: 14px;\n  background: white;\n  outline: none;\n  cursor: pointer;\n}\n.filter-group select:focus { border-color: #ffcc00; }\n\n/* Acțiuni */\n.filtre-actiuni {\n  display: flex;\n  gap: 12px;\n  flex-wrap: wrap;\n}\n.btn-cauta {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 12px 28px;\n  background: #fdb3fd;\n  color: white;\n  border: 2px solid #1a1a1a;\n  border-radius: 12px;\n  font-size: 15px;\n  font-weight: 700;\n  cursor: pointer;\n  box-shadow: 3px 3px 0px #1a1a1a;\n  transition: all 0.2s;\n}\n.btn-cauta:hover {\n  transform: translate(-2px, -2px);\n  box-shadow: 5px 5px 0px #1a1a1a;\n}\n.btn-cauta:disabled { opacity: 0.6; cursor: not-allowed; }\n\n.btn-reset {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  padding: 12px 20px;\n  background: white;\n  color: #666;\n  border: 1.5px solid #ddd;\n  border-radius: 12px;\n  font-size: 14px;\n  cursor: pointer;\n}\n.btn-reset:hover { background: #f3f4f6; }\n\n@media (max-width: 700px) {\n  .filtre-body { flex-direction: column; }\n  .filtre-preview { flex-direction: row; align-items: center; }\n  .filtre-grid { grid-template-columns: repeat(2, 1fr); }\n  .filtre-hero-title { font-size: 2rem; }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
